<script>
export default {
  name: "Header",
  data() {
    return {
      isMenuOpen: false,
    };
  },
  methods: {
    toggleMenu() {
      this.isMenuOpen = !this.isMenuOpen;
    },
    closeMenu() {
      this.isMenuOpen = false;
    },
  },
};
</script>

<template>
  <div id="header">
    <div
      class="hamburger-menu"
      @click="toggleMenu"
      :class="{ 'is-open': isMenuOpen }"
    >
      <div class="bar"></div>
      <div class="bar"></div>
      <div class="bar"></div>
    </div>
    <div class="logo-container">
      <img class="logo" src="../assets/logo.png" alt="Company Logo" />
      <router-link
        to="/"
        class="company-text"
        tag="div"
        @click.native="closeMenu"
        >縁創テック株式会社</router-link
      >
    </div>
    <div class="header-container" :class="{ 'is-open': isMenuOpen }">
      <router-link to="/" tag="div" @click.native="closeMenu"
        >ホーム</router-link
      >
      <router-link to="/services" tag="div" @click.native="closeMenu"
        >事業内容／サービス</router-link
      >
      <router-link to="/about" tag="div" @click.native="closeMenu"
        >会社概要</router-link
      >
      <router-link to="/fundamentalpolicy" tag="div" @click.native="closeMenu"
        >情報セキュリティ方針</router-link
      >
    </div>
  </div>
</template>

<style scoped>
#header {
  display: flex;
  height: 60px;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #212529;
  background-color: #212529;
  backdrop-filter: blur(10px);
  position: relative;
  z-index: 1000;
  color: #ffffff !important;
}

.logo {
  height: 40px;
  width: auto;
  vertical-align: middle;
}

.company-text,
.header-container div {
  font-weight: bolder;
  font-size: large;
}

.logo-container {
  display: flex;
  align-items: center;
  margin-left: 20px;
  cursor: pointer;
}

.header-container {
  display: flex;
  align-items: center;
  height: 100%;
}

.header-container div {
  margin: 0 20px;
  cursor: pointer;
  transition: color 0.3s;
  position: relative;
  padding: 0 10px;
}

.header-container div:hover {
  color: #409eff;
}

.hamburger-menu {
  display: none;
  cursor: pointer;
}

@media (max-width: 960px) {
  #header {
    justify-content: space-between;
    color: #ffffff !important;
  }

  .logo-container {
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    margin-left: 0;
  }

  .hamburger-menu {
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    width: 25px;
    height: 25px;
    margin-left: 20px;
    z-index: 20;
  }

  .hamburger-menu .bar {
    height: 3px;
    width: 100%;
    background-color: #333;
    border-radius: 10px;
    transition: all 0.3s ease-in-out;
  }

  .hamburger-menu.is-open .bar:nth-child(1) {
    transform: translateY(9px) rotate(45deg);
  }
  .hamburger-menu.is-open .bar:nth-child(2) {
    opacity: 0;
  }
  .hamburger-menu.is-open .bar:nth-child(3) {
    transform: translateY(-9px) rotate(-45deg);
  }

  .header-container {
    display: flex;
    flex-direction: column;
    position: absolute;
    top: 60px;
    left: 0;
    right: 0;
    height: auto;
    background-color: #212529;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
    opacity: 0;
    transform: translateY(-10px);
    visibility: hidden;
    transition: opacity 0.3s ease, transform 0.3s ease, visibility 0.3s;
  }

  .header-container.is-open {
    opacity: 1;
    transform: translateY(0);
    visibility: visible;
  }

  .header-container div {
    text-align: center;
    width: 100%;
    padding: 15px 0;
  }

  .header-container div:not(:last-child) {
    border-bottom: 1px solid #212529;
  }
}
</style>
